module.exports = __webpack_public_path__ + "static/media/trip_key_2.2bada5dd.png";